<script setup lang="ts">
defineOptions({ name: "BaseButton" });

withDefaults(
  defineProps<{
    variant?: "primary" | "secondary" | "danger";
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
  }>(),
  {
    variant: "secondary",
    type: "button",
    disabled: false,
  }
);
</script>

<template>
  <button
    :type="type"
    :disabled="disabled"
    class="btn"
    :class="`btn-${variant}`"
  >
    <slot />
  </button>
</template>
